import React from 'react';
import { Route } from 'react-router-dom';
import CatalogueScreen from '../screens/ProductScreens/CatalogueScreen';
import CatalogueCreateProductScreen from '../screens/ProductScreens/CreateProduct';
import * as ROUTES from '../constants/routes';
import OfferingsScreen from '../screens/ProductScreens/OfferingsScreen';
import CreateOfferingScreen from '../screens/ProductScreens/CreateOfferingScreen';

function UserRoutes() {
  return (
    <>
      <Route
        path={ROUTES.PRODUCT_CATALOGUE}
        exact
        component={() => <CatalogueScreen />}
      />
      <Route
        path={ROUTES.CREATE_PRODUCT}
        exact
        component={() => <CatalogueCreateProductScreen />}
      />
      <Route
        path={ROUTES.EDIT_PRODUCT}
        exact
        component={() => <CatalogueCreateProductScreen />}
      />
      <Route
        path={ROUTES.OFFERINGS}
        exact
        component={() => <OfferingsScreen />}
      />
      <Route
        path={ROUTES.CREATE_OFFERINGS}
        exact
        component={() => <CreateOfferingScreen />}
      />

      <Route
        path={ROUTES.EDIT_OFFERINGS}
        exact
        component={() => <CreateOfferingScreen />}
      />
    </>
  );
}

export default UserRoutes;
